var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"fas fa-share-alt",on:{"click":function($event){return _vm.shareVehicle(_vm.vehicle)}}})}
var staticRenderFns = []

export { render, staticRenderFns }